module.exports = __webpack_public_path__ + "img/action_purple.d457d78a.svg";